import { MenuItem, SwipeableDrawer } from "@mui/material";
import closeDropdownIcon from "../../assets/images/bitmaps/close_mobile_dropdown.png";
import style from "./MobileMultDropDown.module.css";
import FormHelperText from "@mui/material/FormHelperText";
import React, { useState, useEffect, useRef } from "react";
import Button from "../../reusables/button/Button";
import closeLabelIcon from "../../../base/assets/icons/close_field.png";
import { useTranslation } from "react-i18next";
interface MobileMultDropDownPropsDI {
  items: Array<{ value: number | string; text: string }>;
  value: number | string | Array<string | number> | null;
  id?: string;
  labelId?: string;
  errorString?: string;
  hasError?: boolean;
  checkedItems: Array<string | number>;
  open: boolean;
  title?: string;
  callBackSetter: (newBool: boolean) => void;
  onChange?: (checkItems: checkedItemsArr[]) => void;
}

interface checkedItemsArr {
  id: string | number;
  checked: boolean;
}

const MobileMultDropDown: React.FC<MobileMultDropDownPropsDI> = (props) => {
  const { t } = useTranslation();
  const [checkedItems, setCheckedItems] = useState<checkedItemsArr[]>([]);
  const [tags, setTags] = useState<string[]>([]);
  const dropdownRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    let updatedTags = [];
    for (let i = 0; i < props.items.length; i++) {
      const itemIsChecked =
        checkedItems.findIndex(
          (el) => el.id == props.items[i].value && el.checked
        ) > -1
          ? true
          : false;
      if (itemIsChecked) {
        updatedTags.push(props.items[i].text);
      }
    }
    setTags(updatedTags);
  }, [checkedItems]);

  useEffect(() => {
    if (props.value && Array.isArray(props.value)) {
      let newCheckItems = [];
      for (let i = 0; i < props.value.length; i++) {
        newCheckItems.push({ id: props.value[i], checked: true });
      }
      setCheckedItems(newCheckItems);
    }
  }, [props.value]);

  const handleCheck = (e: React.ChangeEvent<HTMLInputElement>) => {
    const id = e.target.id;
    let isCheckedIndex = checkedItems.findIndex((el) => el.id == id);
    let newCheckItems = [...checkedItems];
    if (isCheckedIndex > -1) {
      newCheckItems[isCheckedIndex].checked =
        !newCheckItems[isCheckedIndex].checked;
    } else {
      newCheckItems.push({ id: id, checked: true });
    }
    setCheckedItems(newCheckItems);
  };

  const onClickConfirm = () => {
    if (props.onChange) props.onChange(checkedItems);
  };

  const onClickAbort = () => {
    let newCheckItems = [...checkedItems];
    for (let i = 0; i < newCheckItems.length; i++) {
      newCheckItems[i].checked = false;
    }
    setCheckedItems(newCheckItems);
    onClickConfirm();
  };

  const isChecked = (id: string | number) => {
    return (
      checkedItems.findIndex((el) => el.id == id && el.checked == true) > -1
    );
  };

  const deleteField = (name: string) => {
    let deletedFieldId =
      props.items[props.items.findIndex((el) => el.text === name)].value;
    let newCheckItems = [...checkedItems];
    const deletedFieldIndex = newCheckItems.findIndex(
      (el) => el.id == deletedFieldId
    );
    newCheckItems[deletedFieldIndex].checked = false;
    setCheckedItems(newCheckItems);
  };

  const handleDropDownResize = (swipeableRef: any) => {
    if (
      swipeableRef &&
      swipeableRef.current &&
      swipeableRef.current.parentElement
    ) {
      if (swipeableRef.current.clientHeight >= window.innerHeight) {
        swipeableRef.current.parentElement.style.borderRadius = "0";
      } else {
        swipeableRef.current.parentElement.style.borderRadius = "20px 20px 0 0";
      }
    }
  };

  return (
    <React.Fragment>
      <SwipeableDrawer
        anchor={"bottom"}
        open={props.open}
        onClose={() => props.callBackSetter(false)}
        onOpen={() => props.callBackSetter(true)}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
    //    className={'mobileMultipleDropDown__swiperDrawer'}
      >
        <div className={style.MobileMultDropDown__wrapper}>
          <div
            className={style.dropdown_header}
            ref={dropdownRef}
            onLoad={() => handleDropDownResize(dropdownRef)}
          >
            <h4>{props.title}</h4>
            <button onClick={onClickAbort}>
              <img
                src={closeDropdownIcon}
                alt={t("Dropdown-Close-alt")}
                
              />
            </button>
          </div>
          <div className={style.selectItemsWrapper}>
            <div className={style.tags__wrapper}>
              {tags.map((item, index) => {
                return (
                        <button onClick={() => deleteField(item)} aria-label={item + "מחק תגית"}>
                    <div key={index} className={style.tag__wrapper}>

                    <span>{item}</span>
                    <img
                      src={closeLabelIcon}
                      alt="מחק תגית"
                      
                    />
                        
                  </div>
                        </button>
                );
              })}
            </div>
            {props.items.map((item, i) => {
              return (
                <MenuItem
                  key={i}
                  classes={{ root: style.select__item }}
                  value={item.value}
                >
                  <div className={style.type__itemCheckBox}>
                    <input
                      checked={isChecked(item.value)}
                      aria-label={item.text}
                      id={item.value + ""}
                      name={item.text + ""}
                      onChange={handleCheck}
                      type="checkbox"
                    />
                  </div>
                  <p className={style.itemName}>{item.text}</p>
                </MenuItem>
              );
            })}
          </div>

          <div className={style.decisionButtons}>
            <Button
              aria-label={t("Lesson-confirm")}
              variant="filled"
              onClick={onClickConfirm}
            >
              {t("Lesson-confirm")}
            </Button>
            <Button
              aria-label={t("Lesson-cancel")}
              variant="empty"
              onClick={onClickAbort}
            >
              {t("Lesson-cancel")}
            </Button>
          </div>
          <FormHelperText className={style.error}>
            {props.hasError && props.errorString}
          </FormHelperText>
        </div>
      </SwipeableDrawer>
    </React.Fragment>
  );
};
export default MobileMultDropDown;
